<script>
// import lazyLoadComponent from '@router/lazyload-component'
import cloneDeep from 'lodash/cloneDeep'
import { membreLevelValidityTime } from '@utils/memberLevel'
import formatDate from "@utils/format-date";

import {
  genderFilter,
  // findDistrictZip,
  // districtsFilter,
  // taiwanCitys,
  // taxTypeMap,
  // carrierTypeMap,
} from '@utils/filter-value-to-text'

const extraInfoPhone = {
  phoneCode: '+886',
  phoneNumber: ''
}

const extraInfoEmergency = {
  phoneCode: '+886',
  phoneNumber: '',
  fullName: '',
  gender: 'male'
}

const initData = () => {
  return {
    fullName:'',
    gender:'male',
    phone:'',
    phoneCode:'+886',
    phoneNumber:'',
    tags:[],
    email:'',
    lineId:'',
    merchantNote:'',
    extraInfos: {
      extraInfoPhone: [extraInfoPhone],
      extraInfoEmergency: [extraInfoEmergency]
    }
  }
}


export default {
  components: {
    
  },
  filters: {
    genderFilter
  },
  props: {
    memberInfo: {
      type: Object,
      default: () => {}
    }
  },
  mounted(){
  },
  data() {
    return {
      // taiwanCitys,
      // taxTypeMap,
      // carrierTypeMap,
      // submitData: Object.assign({}, initData()),
      // tryingStoreMember: false,
      // activeTab: 'information',
      // editBasicInfoEnabled: false,
      // editInvoiceEnabled: false,
      // // 地址
      // addressMode: 'billing',
      // visibleDialogAddress: false,
      // tryingSaveAddress: false,
      // memberOrderType:'order',
      viewList: [
        {
          text: '會員資訊',
          icon: 'user',
          alias: 'information',
        },
        {
          text: '消費記錄',
          icon: 'eye',
          alias: 'orders',
        },
        {
          text: '客戶備註',
          icon: 'memo',
          alias: 'note',
        }
      ]

    }
  },
  computed: {
    depositReduce(){
      if(!this.memberInfo?.depositInfo) return 0
      const { bonus, point } = this.memberInfo.depositInfo.solution2.reduceDepositTotal
      return bonus + point
    },
    /*************** 會員等級效期 ***************/
    validityTime() {
      // const startedAt = this.memberInfo.level.startedAt
      const expiredAt = this.memberInfo.level.expiredAt
      return expiredAt ? formatDate(expiredAt) : '不限時間'
    }
  },
  watch: {
    // memberInfo: {
    //   handler(val) {
    //     this.submitData = cloneDeep({
    //       ...val,
    //       phone: val.phoneNumber,
    //       merchantNote: val.merchantNote.replace(/<br\s\/>/g, ''),
    //       extraInfos: val.extraInfos 
    //       ?? {
    //         extraInfoPhone: [extraInfoPhone],
    //         extraInfoEmergency: [extraInfoEmergency]
    //       }
    //     })
    //   },
    //   immediate: true,
    // },
  },
  created() {
  },
  methods: {
    formatDate,
    goToDetail(alias) {
      this.$emit('toDetail', alias)
    }
  },
}
</script>
<template>
<div  :class="$style.OrderMemberInfo">
<!-- <h6> <BaseIcon icon-style="fal" name="address-card" /> 客戶資訊</h6> -->
<div :class="$style.infoList">
  <div class="infoList__row">
    <el-row :gutter="20">
      <!-- <el-col :span="24" class="infoList__title"> 客戶資訊</el-col> -->
      <el-col :span="24">
        <el-row :gutter="20" type="flex">
          <el-col :span="24" :md="12" class="infoList__item">
            <span class="text-secondary"> {{ memberInfo.fullName }} {{ memberInfo.gender | genderFilter }} </span>
          </el-col>
          <el-col :span="24" :md="12" class="infoList__item">
            電話：<span class="text-secondary">{{ `${memberInfo.phoneCode} ${memberInfo.phoneNumber}` }}</span>
          </el-col>
          <el-col v-if="$hasDeposit()" :span="24" :md="12" class="infoList__item">儲值點數餘額：<span class="text-primary"> {{ depositReduce }} 點</span></el-col>
          <el-col :span="24" :md="$hasDeposit() ? 12 : 24" class="infoList__item">LINE ID：<span class="text-secondary">{{ memberInfo.lineId }}</span> </el-col>
          <el-col v-if="$hasMemberLevel()" :span="24" :md="12" class="infoList__item">
            <div> <span class="text-color-text-primary">會員等級：</span>
              <el-tag class="isStyleTag mb-0">
                <span class="text-secondary">{{ memberInfo.level.title }}</span>
              </el-tag> 
            </div>
          </el-col>
          <el-col v-if="$hasMemberLevel()" :span="24" :md="12" class="infoList__item">
            <div>
                會員效期：
                <span class="text-secondary">{{ validityTime }}</span>
            </div>
          </el-col>
          <el-col :span="24" class="infoList__item tagList">
            <template v-if="memberInfo.tags.length > 0">
              <div class="mb-2">隸屬標籤：</div> 
              <el-tag v-for="tag in memberInfo.tags" :key="`tag-${tag.id}`" class="isStyleTag " disable-transitions>
                {{ tag.title }}
              </el-tag>
            </template>
            <template v-else>
              <span class="muted"> 目前尚無標籤</span>
            </template>
          </el-col>
        </el-row>
      </el-col>
    </el-row>
  </div>
  <el-divider class="my-2"></el-divider>
  <div class="infoList__view">
    <ul class="viewList__item list-unstyled d-flex w-100">
      <li 
        v-for="(item,index) in viewList"
        :key="index"
        class="viewList__item"
      >
        <el-button class="w-100 isSecondaryText viewList__itemBtn" type="text" @click="goToDetail(item.alias)">
          <BaseIcon :name='item.icon' />
          <span>{{ item.text }}</span>
        </el-button>
      </li>
    </ul>
  </div>
  <!-- <div class="infoList__row">
    <el-row :gutter="20">
      <el-col :span="24" class="infoList__title"> 內部備註</el-col>
      <el-col :span="24" class="infoList__item">
        <span v-if="memberInfo.merchantNote" class="muted" v-html="memberInfo.merchantNote"></span>
        <span v-else>目前尚無備註</span>
      </el-col>
    </el-row>
  </div> -->
  <!-- <div class="only-bottom-line" style="margin-bottom: 30px"></div> -->
</div>
</div>
</template>
<style lang="scss" module>
@import '@design';
.OrderMemberInfo {
  :global {
    .infoList {
      &__item {
        &:not(:last-child) {
          margin-bottom: 1.28rem;
        }
        align-self: center;
        &.tagList {
          .el-tag {
            margin-bottom: 10px;
            &:not(:last-child) {
              margin-right: 10px;
            }
          }
        }
      }
    }
    .viewList {
      &__item {
        flex-grow: 1;
        font-size: 0.75rem;
        &Btn {
          @include max-md {
            font-size: 12px;
            color: #404040;
          }
        }
        svg {
          font-size: 1.25rem;
          color: $color-primary;
          vertical-align: text-top;
          @include max-md {
            font-size: 1rem;
            vertical-align: bottom;
          }
        }
        &:not(:last-child) {
          position: relative;
          &:before {
            content: '';
            position: absolute;
            right: 0;
            top: 50%;
            transform: translateY(-50%);
            height: 50%;
            width: 1px;
            background: #E5E7EB;
          }
        }
      }
    }
  }
}
</style>